"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var decorations = [];

function createDecorator(decorate) {
  return function (Component) {
    var DecoratedComponent = decorate(Component);
    getComponentDecorations(Component).push(DecoratedComponent);
    return DecoratedComponent;
  };
}

exports.createDecorator = createDecorator;

function createWrapDecorator(Wrapper) {
  return createDecorator(function (Component) {
    return function (props) {
      return React.createElement(Wrapper, __assign({}, props), React.createElement(Component, __assign({}, props)));
    };
  });
}

exports.createWrapDecorator = createWrapDecorator;

function combineDecorators() {
  var decorators = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    decorators[_i] = arguments[_i];
  }

  return function (Component) {
    return decorators.reduce(function (Component, decorator) {
      return decorator(Component);
    }, Component);
  };
}

exports.combineDecorators = combineDecorators;

function getComponentDecorations(Component) {
  var foundDecorations = decorations.find(function (decorations) {
    return decorations.indexOf(Component) > -1;
  });

  if (foundDecorations) {
    return foundDecorations;
  }

  var newDecorations = [Component];
  decorations.push(newDecorations);
  return newDecorations;
}

exports.getComponentDecorations = getComponentDecorations;

function getNakedComponent(Component) {
  var result = getComponentDecorations(Component)[0];
  result.defaultProps = __assign(__assign({}, result.defaultProps), {
    classes: {}
  });
  return result;
}

exports.getNakedComponent = getNakedComponent;